module.exports = __webpack_public_path__ + "img/分区09.f4843b97.png";